export const getMenuItems = async () => {
  const items = [
    // {
    //   icon: <TbPlayCardStar className="text-purple-100" />,
    //   label: "Flashcard",
    //   route: "/flashcard",
    // },
    {
      icon: "/icons/shop.svg",
      iconFill: "/icons/shop-fill.svg",
      label: "فروشگاه",
      route: "/",
    },
    // {
    //   icon: "/icons/new-token.svg",
    //   label: "توکن",
    //   route: "/token",
    // },
    // {
    //   icon: "/icons/dashboard.svg",
    //   iconFill: "/icons/dashboard-fill.svg",
    //   label: "داشبورد",
    //   route: "/dashboard",
    // },
    {
      icon: "/icons/wallet.svg",
      iconFill: "/icons/wallet-fill.svg",
      label: "کیف پول",
      route: "/wallet",
    },
    {
      icon: "/icons/ai-chatbot-b.svg",
      iconFill: "/icons/ai-chatbot-p.svg",
      label: "هوش مصنوعی",
      route: "/assistant",
    },
    {
      icon: "/icons/shopping.svg",
      iconFill: "/icons/shopping-fill.svg",
      label: "محصولات",
      route: "/products",
    },
    // {
    //   icon: "/icons/new-profile.svg",
    //   label: "پکیج‌ها",
    //   route: "/packages",
    // },

    // {
    //   icon: "/icons/blue-bell.svg",
    //   label: "اعلانات",
    //   route: "/notifications",
    // },

    // {
    //   icon: <IoCubeOutline className="text-purple-100" />,
    //   label: "Settings",
    //   route: "/settings",
    // },
  ];

  return items;
};
